import React from 'react'
import SALink from 'components/SALink'
import { CollectionImage, Thumbline, Thumb, TitleBanner, ThumbOverlay } from '../../styles'
type Props = {
  collectionTitle: string
  collectionUrl: string
  imageUrl: string
  thumbs: Array<string>
  description: string
}
export default (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { imageUrl, collectionTitle, collectionUrl, thumbs, description } = props
  return (
    <SALink itemProp='url' href={collectionUrl} title={`View ${collectionTitle} collection`}>
      <CollectionImage
        itemProp='contentURL'
        data-type='main-image'
        image={imageUrl}
        alt={`Collection ${collectionTitle}`}
      >
        <TitleBanner>
          <span itemProp='name' data-type='title'>
            {collectionTitle}{' '}
          </span>
          <span data-type='description'>{description}</span>
        </TitleBanner>
      </CollectionImage>

      <Thumbline>
        {thumbs.map((thumb, index) => (
          <Thumb
            key={index}
            itemProp='contentURL'
            data-type='thumb-image'
            image={thumb}
            alt={`Collection ${collectionTitle}`}
          >
            <ThumbOverlay />
          </Thumb>
        ))}
      </Thumbline>
    </SALink>
  )
}